const actions = {
  SET_STATE: 'users/SET_STATE',
  USERS_LIST: 'users/USERS_LIST',
  ADD_USER: 'users/ADD_USER',
  GET_USER: 'users/GET_USER',
  UPDATE_USER: 'users/UPDATE_USER',
  DELETE_USER: 'users/DELETE_USER',
  DEACTIVATE_USER: 'users/DEACTIVATE_USER',
  ACTIVATE_USER: 'users/ACTIVATE_USER',
  SEARCH_USER: 'users/SEARCH_USER',
  ENTER_USER_TEXT: 'users/ENTER_USER_TEXT',
  USERS_INACTIVE_LIST: 'users/USERS_INACTIVE_LIST',
  ENTER_USER_INACTIVE_TEXT: 'users/ENTER_USER_INACTIVE_TEXT',
  SEARCH_INACTIVE_USER: 'users/SEARCH_INACTIVE_USER',
  USER_AUTH_TOKENS_LIST: 'users/USER_AUTH_TOKENS_LIST',
  ADD_USER_AUTH_TOKEN: 'users/ADD_USER_AUTH_TOKEN',
  DELETE_USER_AUTH_TOKEN: 'users/DELETE_USER_AUTH_TOKEN',
  ENTER_UAUTHTOKEN_TEXT: 'users/ENTER_UAUTHTOKEN_TEXT',
  SEARCH_UAUTHTOKEN: 'users/SEARCH_UAUTHTOKEN',
  USER_FRIENDS_LIST: 'users/USER_FRIENDS_LIST',
  ENTER_USER_FRIEND_LIST_TEXT: 'users/ENTER_USER_FRIEND_LIST_TEXT',
  SEARCH_USER_FRIEND_LIST: 'users/SEARCH_USER_FRIEND_LIST',
  UPDATE_USER_FRIENDS: 'users/UPDATE_USER_FRIENDS',
  ADD_FRIEND_TO_USER: 'users/ADD_FRIEND_TO_USER',
  ENTER_USER_FRIEND_TEXT: 'users/ENTER_USER_FRIEND_TEXT',
  SEARCH_USER_FRIEND: 'users/SEARCH_USER_FRIEND',
  UNFRIEND_USER: 'users/UNFRIEND_USER',
  NON_USER_FRIEND_LIST_MODAL: 'users/NON_USER_FRIEND_LIST_MODAL',
  ENTER_NON_FRIEND_LIST_TEXT: 'users/ENTER_NON_FRIEND_LIST_TEXT',
  SEARCH_NON_FRIEND_LIST_MODAL: 'users/SEARCH_NON_FRIEND_LIST_MODAL',
  USER_GROUPS_LIST: 'users/USER_GROUPS_LIST',
  ENTER_USER_GROUP_LIST_TEXT: 'users/ENTER_USER_GROUP_LIST_TEXT',
  SEARCH_GROUP_FRIEND_LIST: 'users/SEARCH_GROUP_FRIEND_LIST',
  KICK_USER_FROM_GROUP: 'users/KICK_USER_FROM_GROUP',
  BAN_USER_FROM_GROUP: 'users/BAN_USER_FROM_GROUP',
  ADD_USER_TO_GROUP: 'users/ADD_USER_TO_GROUP',
  NON_USER_GROUP_LIST_MODAL: 'users/NON_USER_GROUP_LIST_MODAL',
  ENTER_NON_GROUP_LIST_TEXT: 'users/ENTER_NON_GROUP_LIST_TEXT',
  SEARCH_NON_GROUP_LIST_MODAL: 'users/SEARCH_NON_GROUP_LIST_MODAL',
  SEARCH_USER_GROUP: 'users/SEARCH_USER_GROUP',
  ENTER_USER_GROUP_TEXT: 'users/ENTER_USER_GROUP_TEXT',
  AI_AGENT_USER_LIST: 'users/AI_AGENT_USER_LIST',
  SHOW_IMPORT_USER_REQUEST: 'users/SHOW_IMPORT_USER_REQUEST',
  IMPORT_USERS_REQUEST_MANUAL_INTENT: 'users/IMPORT_USERS_REQUEST_MANUAL_INTENT',
}

export default actions
